export default __webpack_public_path__ + "static/media/cross.cf4dbaee.svg";